export default "__VITE_ASSET__sKP3uGnp__"